import { useEffect } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import { IconFiles, Icon3dCubeSphere, IconDownload, IconBuildingFactory2, IconChevronRight } from '@tabler/icons-react';

export const Home = () => {
    const { t } = useTranslation();

    const featureCards = [
        {
            icon: <IconFiles size={30} />,
            title: t('menuUrunDosyalari'),
            desc: t('mesajHosgeldiniz'),
            path: '/productlist',
            color: '#2563a8',
            bg: '#eff6ff',
        },
        {
            icon: <Icon3dCubeSphere size={30} />,
            title: t('menu3DUrunler'),
            desc: t('mesajHosgeldiniz1'),
            path: '/ThreeDProducts',
            color: '#0e7c5a',
            bg: '#f0fdf4',
        },
        {
            icon: <IconDownload size={30} />,
            title: t('menuIndirdigimUrunler'),
            desc: null,
            path: '/downloaded',
            color: '#7c3aed',
            bg: '#faf5ff',
        },
    ];

    return (
        <div style={{ maxWidth: '900px' }}>

            {/* Hero */}
            <div className="rounded-4 mb-4 p-4"
                style={{ background: 'linear-gradient(135deg, #1e2a38 0%, #2563a8 100%)' }}>
                <h5 className="fw-bold text-white mb-2">{t('baslikHosgeldiniz')}</h5>
                <p className="mb-1" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '14px', marginBottom: 4 }}>
                    {t('mesajHosgeldiniz')}
                </p>
                <p className="mb-0" style={{ color: 'rgba(255,255,255,0.55)', fontSize: '13px' }}>
                    {t('mesajHosgeldiniz1')}
                </p>
            </div>

            {/* Hızlı Erişim Kartları */}
            <div className="row g-3 mb-4">
                {featureCards.map((card, i) => (
                    <div className="col-md-4" key={i}>
                        <Link to={card.path} className="text-decoration-none">
                            <div className="card border-0 shadow-sm rounded-4 h-100 p-3"
                                style={{ transition: 'transform 0.15s, box-shadow 0.15s', cursor: 'pointer' }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '';
                                }}>
                                <div className="rounded-3 d-inline-flex p-2 mb-3"
                                    style={{ background: card.bg, color: card.color }}>
                                    {card.icon}
                                </div>
                                <h6 className="fw-bold mb-2" style={{ color: '#1e293b' }}>{card.title}</h6>
                                {card.desc && (
                                    <p className="text-muted mb-3" style={{ fontSize: '13px', lineHeight: 1.5 }}>
                                        {card.desc}
                                    </p>
                                )}
                                <div className="mt-auto d-flex align-items-center gap-1"
                                    style={{ color: card.color, fontSize: '13px', fontWeight: 600 }}>
                                    {t('butonUrunleriGor')}
                                    <IconChevronRight size={15} />
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>

            {/* Hakkımızda */}
            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                    <div className="d-flex align-items-center gap-2 mb-3"
                        style={{ color: '#94a3b8', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
                        <IconBuildingFactory2 size={14} />
                        {t('baslikHakkimizda')}
                    </div>
                    <div className="d-flex gap-4 align-items-start">
                        <div style={{ flex: 1 }}>
                            <p style={{ color: '#334155', fontSize: '14px', lineHeight: 1.7, marginBottom: 12 }}>
                                {t('metinHakkimizda1')}
                            </p>
                            <p style={{ color: '#475569', fontSize: '14px', lineHeight: 1.7, marginBottom: 0 }}>
                                {t('metinHakkimizda2')}
                            </p>
                        </div>
                        <img src={t('logoKama')} alt="Kama"
                            style={{ width: 100, flexShrink: 0, opacity: 0.7, alignSelf: 'center' }} />
                    </div>
                </div>
            </div>

        </div>
    )
}